module.exports = __webpack_public_path__ + "media/images/landing/home/categories/mobile-9e543e68b90917a92cc1ecce5c43d29f.png";